import { createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5bf8829d")

_pushScopeId("data-v-5bf8829d")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "head" }, [
  /*#__PURE__*/_createVNode("span", { class: "title" }, "Add Data")
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("calcite-tab-nav", { slot: "tab-nav" }, [
  /*#__PURE__*/_createVNode("calcite-tab-title", { active: "" }, "Url"),
  /*#__PURE__*/_createVNode("calcite-tab-title", { id: "ships" }, "File"),
  /*#__PURE__*/_createVNode("calcite-tab-title", { id: "ships" }, "Layer")
], -1)
const _hoisted_3 = { class: "url-tab" }
const _hoisted_4 = { class: "type" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "Type", -1)
const _hoisted_6 = {
  ref: "fileTypes",
  label: "urlType"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("calcite-option", { value: "csv" }, "A CSV File", -1)
const _hoisted_8 = { class: "url" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "URL", -1)
const _hoisted_10 = { ref: "calciteInputUrl" }
const _hoisted_11 = { class: "file-tab" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "supported-file-types" }, [
  /*#__PURE__*/_createVNode("img", {
    src: "https://citecdevgroup.maps.arcgis.com/apps/webappviewer/widgets/AddData/images/filetypes/csv.svg",
    alt: "CSV",
    class: "first-type-icon CSV"
  }),
  /*#__PURE__*/_createVNode("img", {
    src: "https://citecdevgroup.maps.arcgis.com/apps/webappviewer/widgets/AddData/images/filetypes/geojson.svg",
    alt: "GeoJSON",
    class: "second-last-type-icon GeoJSON"
  })
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "or" }, "DROP FILES OR ", -1)
const _hoisted_14 = {
  class: "file-form",
  enctype: "multipart/form-data",
  method: "post"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("label", {
  for: "dijit__WidgetsInTemplateMixin_2_file",
  class: "browse"
}, "Browse", -1)
const _hoisted_16 = { class: "layer-tab" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"header\" data-v-5bf8829d><span class=\"name\" data-v-5bf8829d>Name</span><span class=\"color\" data-v-5bf8829d>Color</span><span class=\"visibility\" data-v-5bf8829d>Visibility</span><span class=\"remove\" data-v-5bf8829d>Remove</span></div>", 1)
const _hoisted_18 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_19 = { class: "item" }
const _hoisted_20 = { class: "colorItem" }
const _hoisted_21 = { class: "visibilityItem" }
const _hoisted_22 = { class: "removeItem" }
const _hoisted_23 = { ref: "colorPicker" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx, _cache) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", {
      class: ["esri-widget addData-container", {'containerWidth': _ctx.showReverse}]
    }, [
      _hoisted_1,
      _createVNode("calcite-tabs", null, [
        _hoisted_2,
        _createVNode("calcite-tab", null, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode("calcite-select", _hoisted_6, [
                _hoisted_7
              ], 512)
            ]),
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("calcite-input", _hoisted_10, null, 512)
            ]),
            _createVNode("calcite-button", {
              ref: "addUrls",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.addUrl())),
              color: "blue",
              scale: "m"
            }, "Add", 512)
          ])
        ]),
        _createVNode("calcite-tab", _hoisted_11, [
          _createVNode("div", {
            class: "drop-area",
            dropZoneActive: _ctx.active,
            onDrop: _cache[3] || (_cache[3] = _withModifiers((...args) => (_ctx.addFile && _ctx.addFile(...args)), ["prevent"])),
            onDragover: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _hoisted_12,
            _hoisted_13,
            _createVNode("form", _hoisted_14, [
              _hoisted_15,
              _createVNode("input", {
                id: "dijit__WidgetsInTemplateMixin_2_file",
                name: "file",
                type: "file",
                onChange: _cache[2] || (_cache[2] = (...args) => (_ctx.addFile && _ctx.addFile(...args))),
                style: {"display":"none"}
              }, null, 32)
            ])
          ], 40, ["dropZoneActive"])
        ]),
        _createVNode("calcite-tab", _hoisted_16, [
          _hoisted_17,
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.allLayer, (layer, index) => {
            return (_openBlock(), _createBlock("div", _hoisted_18, [
              _createVNode("div", {
                class: ["nameItem", { 'nameItem2': !layer.canBeSaved }]
              }, [
                (_ctx.editName != index)
                  ? (_openBlock(), _createBlock("span", {
                      key: 0,
                      onDblclick: $event => (_ctx.EditName(index))
                    }, _toDisplayString(layer.name), 41, ["onDblclick"]))
                  : _createCommentVNode("", true),
                (_ctx.editName == index)
                  ? (_openBlock(), _createBlock("div", {
                      key: 1,
                      class: "closeNameEditPanel",
                      onClick: _cache[5] || (_cache[5] = $event => (_ctx.HideEditName()))
                    }))
                  : _createCommentVNode("", true),
                (_ctx.editName == index)
                  ? (_openBlock(), _createBlock("calcite-input", {
                      key: 2,
                      value: layer.name,
                      id: index,
                      label: "nameEdit"
                    }, null, 8, ["value", "id"]))
                  : _createCommentVNode("", true)
              ], 2),
              _createVNode("div", _hoisted_19, [
                (layer.canBeSaved == true)
                  ? (_openBlock(), _createBlock("calcite-select", {
                      key: 0,
                      id: index,
                      label: "uiConfig"
                    }, [
                      _createVNode("calcite-option", {
                        value: "0",
                        selected: layer.uiConfig == 0
                      }, "Default", 8, ["selected"]),
                      _createVNode("calcite-option", {
                        value: "1",
                        selected: layer.uiConfig == 1
                      }, "Location Types", 8, ["selected"]),
                      _createVNode("calcite-option", {
                        value: "2",
                        selected: layer.uiConfig == 2
                      }, "GIS Configuration", 8, ["selected"]),
                      _createVNode("calcite-option", {
                        value: "3",
                        selected: layer.uiConfig == 3
                      }, "MapView", 8, ["selected"]),
                      _createVNode("calcite-option", {
                        value: "4",
                        selected: layer.uiConfig == 4
                      }, "Passenger Portal", 8, ["selected"]),
                      _createVNode("calcite-option", {
                        value: "5",
                        selected: layer.uiConfig == 5
                      }, "Transportation Point", 8, ["selected"])
                    ], 8, ["id"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_20, [
                _createVNode("div", null, [
                  _createVNode("span", {
                    style: [{color:layer.color}, {"font-size":"30px"}],
                    onClick: $event => (_ctx.ShowColor(index))
                  }, "■", 12, ["onClick"])
                ])
              ]),
              _createVNode("div", _hoisted_21, [
                (layer.visible == true)
                  ? (_openBlock(), _createBlock("span", {
                      key: 0,
                      class: "esri-icon-visible",
                      "aria-hidden": "true",
                      onClick: $event => (_ctx.ToogleVisibleLayer(index))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (layer.visible != true)
                  ? (_openBlock(), _createBlock("span", {
                      key: 1,
                      class: "esri-icon-non-visible",
                      "aria-hidden": "true",
                      onClick: $event => (_ctx.ToogleVisibleLayer(index))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_22, [
                _createVNode("span", {
                  class: "esri-icon-trash",
                  style: {"margin-left":"25px"},
                  onClick: $event => (_ctx.DeleteLayer(index))
                }, null, 8, ["onClick"])
              ])
            ]))
          }), 256)),
          (_ctx.showColor == true)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "closeColorPickerPanel",
                onClick: _cache[6] || (_cache[6] = $event => (_ctx.HideColor()))
              }))
            : _createCommentVNode("", true),
          _createVNode("div", {
            style: [[_ctx.showColor == true ? 'display: block' : 'display: none'], {"position":"absolute"}]
          }, [
            _createVNode("calcite-color-picker", _hoisted_23, null, 512)
          ], 4)
        ])
      ])
    ], 2)
  ]))
})